/* Product Quiz — screens, questions and results */
(function () {
  'use strict';

  const State = window.ProductQuizState;

  const root = document.querySelector('.js-quiz-root');
  if (!root || !State) return;

  const screens = root.querySelectorAll('.js-quiz-screen');
  const progress = root.querySelector('.js-quiz-progress');
  const titleEl = root.querySelector('.js-quiz-question-title');
  const subtitleEl = root.querySelector('.js-quiz-question-subtitle');
  const optionsEl = root.querySelector('.js-quiz-options');
  const continueBtn = root.querySelector('.js-quiz-continue');
  const backBtn = root.querySelector('.js-quiz-back');
  const holding = root.querySelector('.js-quiz-holding');
  const plus = root.querySelector('.js-quiz-plus');

  // Cards shown under each top match
  const OTHERS_COUNT = 3;

  /* Analytics */

  // Page the quiz is on, set by the section
  const QUIZ_LOCATION = root.dataset.quizLocation;

  // Event params with quiz_location added
  function withLocation(params) {
    const payload = Object.assign({}, params);
    if (QUIZ_LOCATION) payload.quiz_location = QUIZ_LOCATION;
    return payload;
  }

  // Option ids, in the question's option order for multi-select
  function answerValue(question) {
    const answer = State.getAnswer(question.id);
    if (!Array.isArray(answer)) return answer;
    return question.options
      .filter((option) => answer.indexOf(option.id) !== -1)
      .map((option) => option.id)
      .join(',');
  }

  function trackAnswer(step) {
    const question = State.questionAt(step);
    window.GoogleAnalytics?.track('quiz_answer', withLocation({
      question_id: question.id,
      answer: answerValue(question),
      step: step + 1,
      quiz_path: State.getState().path,
    }));
  }

  // Top harness and dildo shown on results
  function trackComplete() {
    const params = { quiz_path: State.getState().path };
    ['harness', 'dildo'].forEach((pool) => {
      const card = slotFor(pool, 'top').querySelector('.quiz-card');
      if (card) params['top_' + pool] = card.dataset.productHandle;
    });
    window.GoogleAnalytics?.track('quiz_complete', withLocation(params));
  }

  // Result card links and quick add
  function onResultClick(event) {
    const target = event.target.closest(
      '.quiz-card__link, .quiz-card__media, .quiz-card__add'
    );
    if (!target) return;

    const card = target.closest('.quiz-card');
    const slot = card.closest('.js-quiz-slot');
    if (!slot) return;

    window.GoogleAnalytics?.track(
      target.classList.contains('quiz-card__add')
        ? 'quiz_quick_add'
        : 'quiz_result_click',
      withLocation({
        product_handle: card.dataset.productHandle,
        pool: slot.dataset.pool,
        slot: slot.dataset.slot,
        position:
          slot.dataset.slot === 'top'
            ? 1
            : Array.from(slot.children).indexOf(card) + 2,
        quiz_path: State.getState().path,
      })
    );
  }

  /* Screens */

  function showScreen(name) {
    screens.forEach((screen) => {
      screen.toggleAttribute('hidden', screen.dataset.screen !== name);
    });
  }

  // Replay the enter animation on the reused question screen
  function animateIn(name) {
    const screen = root.querySelector(`.js-quiz-screen[data-screen="${name}"]`);
    screen.classList.remove('is-entering');
    void screen.offsetWidth;
    screen.classList.add('is-entering');
  }

  // Show the screen for the current step, moving focus only when `focus` is set
  function render(options) {
    const shouldFocus = Boolean(options && options.focus);
    const state = State.getState();

    if (state.step < 0) {
      showScreen('intro');
      animateIn('intro');
      setProgress(0);
      return;
    }

    if (state.step >= State.totalSteps()) {
      showScreen('results');
      animateIn('results');
      setProgress(100);
      State.loadScores(root.dataset.scoresUrl).then(placeResults);
      return;
    }

    showScreen('question');
    renderQuestion(State.questionAt(state.step), shouldFocus);
    animateIn('question');
    setProgress(((state.step + 1) / State.totalSteps()) * 100);
  }

  function setProgress(pct) {
    progress.style.width = pct + '%';
  }

  /* Results */

  // Return every card to the holding area, then move the ranked ones into their slots
  function placeResults() {
    root
      .querySelectorAll('.js-quiz-slot .quiz-card')
      .forEach((card) => holding.appendChild(card));

    const results = State.getResults();
    let poolsShown = 0;

    root.querySelectorAll('.js-quiz-pool').forEach((poolEl) => {
      const pool = poolEl.dataset.pool;
      const cards = (results[pool] || [])
        .slice(0, OTHERS_COUNT + 1)
        .map((product) => cardFor(product.handle))
        .filter(Boolean);

      poolEl.toggleAttribute('hidden', cards.length === 0);
      if (cards.length === 0) return;
      poolsShown += 1;

      slotFor(pool, 'top').append(cards[0]);
      slotFor(pool, 'others').append(...cards.slice(1));

      // Hide the "other options" heading when there's nothing under it
      poolEl
        .querySelector('.quiz__others-label')
        .toggleAttribute('hidden', cards.length === 1);
    });

    plus.toggleAttribute('hidden', poolsShown < 2);
  }

  function cardFor(handle) {
    return root.querySelector(
      `.quiz-card[data-product-handle="${CSS.escape(handle)}"]`
    );
  }

  function slotFor(pool, slot) {
    return root.querySelector(
      `.js-quiz-slot[data-pool="${pool}"][data-slot="${slot}"]`
    );
  }

  /* Question rendering */

  function renderQuestion(question, shouldFocus) {
    titleEl.textContent = question.title;
    titleEl.id = 'quiz-question-' + question.id;
    subtitleEl.toggleAttribute('hidden', question.type !== 'multi');

    // Group the options and name them by the question for screen readers
    optionsEl.setAttribute(
      'role',
      question.type === 'multi' ? 'group' : 'radiogroup'
    );
    optionsEl.setAttribute('aria-labelledby', titleEl.id);

    const answer = State.getAnswer(question.id);

    optionsEl.innerHTML = '';
    question.options.forEach((option) => {
      optionsEl.appendChild(buildOption(question, option, answer));
    });

    // One tab stop for the group, on the current answer if there is one
    const buttons = optionButtons();
    const active = buttons.findIndex((b) => b.dataset.selected === 'true');
    setTabStop(buttons, active === -1 ? 0 : active);

    if (shouldFocus) buttons[active === -1 ? 0 : active].focus();

    // Continue shows once the question is answered
    continueBtn.toggleAttribute('hidden', !hasAnswer(question));
    backBtn.toggleAttribute('hidden', State.getState().step === 0);
  }

  function buildOption(question, option, answer) {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'quiz__option js-quiz-option';
    button.dataset.optionId = option.id;
    button.dataset.selected = isSelected(option.id, answer) ? 'true' : 'false';
    button.setAttribute('role', question.type === 'multi' ? 'checkbox' : 'radio');
    button.setAttribute('aria-checked', button.dataset.selected);

    const marker = document.createElement('span');
    marker.className = 'quiz__option-marker';
    marker.setAttribute('aria-hidden', 'true');

    const label = document.createElement('span');
    label.className = 'quiz__option-label';
    label.textContent = option.label;

    button.append(marker, label);
    button.addEventListener('click', () => selectOption(question, option.id));
    button.addEventListener('keydown', onOptionKey);

    return button;
  }

  /* Keyboard — arrows move focus without selecting, since selecting advances */
  function optionButtons() {
    return Array.from(optionsEl.querySelectorAll('.js-quiz-option'));
  }

  function setTabStop(buttons, index) {
    buttons.forEach((button, i) => {
      button.tabIndex = i === index ? 0 : -1;
    });
  }

  const NEXT_KEYS = ['ArrowDown', 'ArrowRight'];
  const PREV_KEYS = ['ArrowUp', 'ArrowLeft'];

  function onOptionKey(event) {
    const buttons = optionButtons();
    const current = buttons.indexOf(event.currentTarget);
    let next = -1;

    if (NEXT_KEYS.indexOf(event.key) !== -1) next = (current + 1) % buttons.length;
    else if (PREV_KEYS.indexOf(event.key) !== -1) next = (current - 1 + buttons.length) % buttons.length;
    else if (event.key === 'Home') next = 0;
    else if (event.key === 'End') next = buttons.length - 1;
    else return;

    event.preventDefault();
    setTabStop(buttons, next);
    buttons[next].focus();
  }

  function isSelected(optionId, answer) {
    return Array.isArray(answer)
      ? answer.indexOf(optionId) !== -1
      : answer === optionId;
  }

  function hasAnswer(question) {
    const answer = State.getAnswer(question.id);
    return Array.isArray(answer) ? answer.length > 0 : Boolean(answer);
  }

  /* Selection */

  // Pause between selecting and advancing
  const ADVANCE_DELAY = 350;
  let advancing = false;

  function selectOption(question, optionId) {
    // Ignore picks while advancing
    if (advancing) return;

    if (question.type === 'multi') {
      State.toggleAnswer(question.id, optionId);

      // Update just this button so focus stays put
      const button = optionsEl.querySelector(
        `.js-quiz-option[data-option-id="${optionId}"]`
      );
      const on = isSelected(optionId, State.getAnswer(question.id));
      button.dataset.selected = on ? 'true' : 'false';
      button.setAttribute('aria-checked', button.dataset.selected);

      continueBtn.toggleAttribute('hidden', !hasAnswer(question));
      return;
    }

    State.setAnswer(question.id, optionId);

    // Show the selection before moving on
    markSelected(optionId);
    advancing = true;
    window.setTimeout(() => {
      advancing = false;
      goNext();
    }, ADVANCE_DELAY);
  }

  // Mark one option selected and clear the rest
  function markSelected(optionId) {
    optionButtons().forEach((button) => {
      const on = button.dataset.optionId === optionId;
      button.dataset.selected = on ? 'true' : 'false';
      button.setAttribute('aria-checked', button.dataset.selected);
    });
  }

  /* Navigation */

  function goNext() {
    const step = State.getState().step;
    trackAnswer(step);

    State.setStep(step + 1);
    render({ focus: true });

    // Track completion once results are placed
    if (State.getState().finished) {
      State.loadScores(root.dataset.scoresUrl).then(trackComplete);
    }
  }

  function goBack() {
    const step = State.getState().step;
    window.GoogleAnalytics?.track('quiz_back', withLocation({
      question_id: State.questionAt(step).id,
      step: step + 1,
      quiz_path: State.getState().path,
    }));

    State.setStep(step - 1);
    render({ focus: true });
  }

  root.querySelector('.js-quiz-start').addEventListener('click', () => {
    State.setStep(0);
    window.GoogleAnalytics?.track('quiz_start', withLocation());
    render({ focus: true });
  });

  continueBtn.addEventListener('click', goNext);
  backBtn.addEventListener('click', goBack);

  root.querySelector('.js-quiz-retake').addEventListener('click', () => {
    window.GoogleAnalytics?.track('quiz_retake', withLocation({ quiz_path: State.getState().path }));
    State.reset();
    render();
  });

  root.addEventListener('click', onResultClick);

  render();
})();
